import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'NameArray'
})
export class NameArrayPipe implements PipeTransform {

    transform(id: string, array: any): any {
        const result = array.filter(value => value.id == id);
        if (result.length > 0) {
            return result[0].name;
        }
    }

}


// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/pipes/string/nameArrayId.pipe.ts